export class AbstractProductType {
    code = null;      
    name = null;  
    description= null;
    parent = null
    productType= null
}